<p mat-dialog-title class='popup-title text-title-size'>
    {{domain}}
</p>

<mat-dialog-content class="dialog-content">

    <mat-tab-group mat-stretch-tabs="true" animationDuration="200ms" class="tabs-group">

        <!-- Tab - General settings -->
        <mat-tab label={{languageService.Strings.messages.tab_generalSettings}}>

            <!-- Top section -->
            <div class="tab-general-settings">

                <!-- Notification email -->
                <div class="entry-full-width noraml-text-size">
                    <span>{{languageService.Strings.messages.input_box_notificationEmail}}</span>
                    <span>{{information.notificationEmail}}</span>
                </div>

                <!-- Starting timestamp -->
                <div class="entry-full-width noraml-text-size">
                    <span>{{languageService.Strings.messages.input_box_startingTimestamp}}</span>
                    <span>{{getFormattedDate(information.startingTimestamp)}}</span>
                </div>

                <!-- Button-Menu - Language -->
                <div class="entry-full-width noraml-text-size">
                    <span>{{languageService.Strings.buttons.button_targetLanguage}}</span>
                    <button 
                        mat-raised-button 
                        color="primary" 
                        class="reduced_button"
                        [matMenuTriggerFor]="menuLanguageCode" 
                        >
                            {{optionMenu_LanguageCode_value}}
                    </button> 
                </div>
                <mat-menu #menuLanguageCode="matMenu" yPosition="below">
                    <button mat-menu-item *ngFor="let item of optionMenu_LanguageCode_OptionList; let i=index"
                    (click)="optionMenuClicked_LanguageCode(item)" >
                        {{item}}
                    </button>
                </mat-menu>

                <!-- Button-Menu - Password Rotation (only if email and password auth is available) -->
                <div class="entry-full-width noraml-text-size" *ngIf="this.information.emailPasswordAuth === true">
                    <span>{{languageService.Strings.buttons.button_passwordRotation}}</span>
                    <button 
                        mat-raised-button 
                        color="primary" 
                        class="reduced_button"
                        [matMenuTriggerFor]="menuPasswordRotation" 
                        >
                            {{optionMenu_PasswordRotation_value}}
                    </button> 
                </div>
                <mat-menu #menuPasswordRotation="matMenu" yPosition="below">
                    <button mat-menu-item *ngFor="let item of optionMenu_PasswordRotation_OptionList; let i=index"
                    (click)="optionMenuClicked_PasswordRotation(item)" >
                        {{item}}
                    </button>
                </mat-menu>

                <!-- Toogle - Collaborator for DB -->
                <div class="entry-full-width noraml-text-size">
                    <span>{{languageService.Strings.buttons.button_dbCollaborator}}</span>
                    <mat-slide-toggle
                        color="primary"
                        [formControl]="formControl_isCollaborator">
                    </mat-slide-toggle>
                </div>

                <!-- Ending timestamp -->
                <div class="entry-full-width noraml-text-size">
                    <span>{{languageService.Strings.messages.input_box_endingTimestamp}}</span>
                    <!-- Date field -->
                    <mat-form-field class="input-text" appearance="fill">
                        <input matInput 
                            [matDatepicker]="picker" 
                            [formControl]="formControl_endingTimestamp" 
                            required 
                            autocomplete="off"
                            readonly                  
                            (click)="picker.open()">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>        
                        <mat-datepicker #picker 
                                        startView="multi-year"
                                        panelClass="month-picker"
                                        [startView]="'multi-year'"
                                        [touchUi]="true"
                                        [startAt]="startDate">
                        </mat-datepicker>
                    </mat-form-field>
                </div>                

            </div>
        
        </mat-tab>
    
        <!-- Tab - User settings -->
        <mat-tab label={{languageService.Strings.messages.tab_userSettings}}>

            <!-- List - Existing users -->
            <div class="tab-user-settings">
                <mat-list role="list">

                    <!-- User list -->
                    <ng-container *ngFor="let user of users | keyvalue; let last = last">
                        <mat-list-item role="listitem">
                            <mat-icon matListItemIcon>person</mat-icon>
                            <span matListItemTitle>{{ user.key }}</span>
                            <div matListItemMeta class="action-buttons">
                                <mat-checkbox 
                                    color="primary"
                                    [checked]="user.value.includes('owner')"
                                    (change)="checkboxClicked_updateRole(user.key, 'owner', $event.checked)">
                                    Owner
                                </mat-checkbox>
                                <mat-checkbox 
                                    color="primary"
                                    [checked]="user.value.includes('admin')"
                                    (change)="checkboxClicked_updateRole(user.key, 'admin', $event.checked)">
                                    Admin
                                </mat-checkbox>
                                <mat-checkbox 
                                    color="primary"
                                    [checked]="user.value.includes('user')"
                                    (change)="checkboxClicked_updateRole(user.key, 'user', $event.checked)">
                                    User
                                </mat-checkbox>
                                <button mat-icon-button color="warn" (click)="buttonClicked_deleteUser(user.key)">
                                    <mat-icon>delete</mat-icon>
                                </button>                                                
                            </div>
                        </mat-list-item>
                        <mat-divider *ngIf="!last" class="divider"></mat-divider>
                    </ng-container>

                    <!-- New user section -->
                    <mat-list-item class="add-user-row">
                        <mat-icon matListItemIcon color="primary">person_add</mat-icon>
                        <div matListItemTitle>
                            <input #newUserInput 
                                type="text" 
                                placeholder="New username..." 
                                class="new-user-input"
                                (keyup.enter)="buttonClicked_addUser(newUserInput.value); newUserInput.value = ''">
                        </div>
                        <div matListItemMeta>
                            <button mat-icon-button color="primary" (click)="buttonClicked_addUser(newUserInput.value); newUserInput.value = ''">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                        </div>
                    </mat-list-item>

                </mat-list>
            </div>

         </mat-tab>

    </mat-tab-group>
        

</mat-dialog-content>





<mat-dialog-actions id="actions-conatiner">

    <div class="base_buttons_container">
        <!-- Close button --> 
        <button mat-raised-button 
                color="primary" 
                class="base_buttons" 
                (click)="cancelButtonClicked()">
            {{languageService.Strings.buttons.button_cancel}}
        </button>  
        <!-- Accept button -->       
        <button mat-raised-button 
                cdkFocusInitial
                color="primary"
                class="base_buttons"
                [disabled]="!formIsValid()"
                (click)="acceptButtonClicked()" > 
            {{languageService.Strings.buttons.button_accept}}
        </button>    
    </div>
    
</mat-dialog-actions>



<!-- Waiting spinner -->
<div *ngIf="(displayWaitingPopup)" >
    <app-waiting-popup [waitingMessage]="waitingMessage" ></app-waiting-popup> 
</div>